// extracted by mini-css-extract-plugin
export var sliderRange = "_o1-2";
export var sliderRoot = "_o1-0";
export var sliderThumb = "_o1-3";
export var sliderTrack = "_o1-1";